var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":this.message !== null,"timeout":_vm.data.messageTimeout,"text":"","color":this.color,"center":"","close":""}},[_vm._v(" "+_vm._s(this.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }